const { axios, API_URL, generateHeaders, queryParamsToPathParams } = require('./helper');

/************* Authorizations *************/

/**
 * @description description
 */
const createAuth = async (referral, txnId) => {
    const body = {
        "CreateAuthorization": {
            "EmpDepAuthorization": {
                ...referral
            }
        }
    }
    const response = await axios.post(`${API_URL}pureProxy/core/createAuthorizations`, body, {
        headers: generateHeaders(null, {
            'X-Transaction-ID': txnId
        })
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns all authorizations for an employee through JV.
 */
const getEmployeeAuthorizationsByEmployeeId = async (employeeId) => {
    const params = {
        EmployeeID: employeeId
    }
    let url = queryParamsToPathParams(params, `${API_URL}pureProxy/core/listAuthorizations`)
    const response = await axios.get(url, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns authorization details by employee ID and authorization number
 */
const getEmployeeAuthorizationsByEmployeeIdAndAuthorizationNumber = async (employeeId, authorizationNumber) => {
    const params = {
        EmployeeID: employeeId,
        AuthorizationNumber: authorizationNumber
    }
    let url = queryParamsToPathParams(params, `${API_URL}pureProxy/core/readAuthorizations`)
    const response = await axios.get(url, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description description
 */
const updateAuthorizationSpecialty = async (referral, member, specialtyCode, txnId) => {
    const body = {
        "UpdateAuthorization": {
            "EmpDepAuthorization": {
                "EmployeeID": member.EmployeeID,
                "DepSequenceNumber": member.DepSequenceNumber,
                "AuthorizationType": referral.AuthorizationType,
                "AuthorizationNumber": referral.AuthorizationNumber,
                "ProviderRule": referral.ProviderRule,
                "ProviderSpecialty": specialtyCode,
                "AuthorizedTotals": {
                    "AuthActions": referral.AuthActions, //EE
                    "EmpDepAuthCategory": [
                        {
                            "AuthorizationCategory": referral.AuthorizationCategory //AUTH-See Services
                        }
                    ]
                }
            }
        }
    }
    const response = await axios.put(`${API_URL}pureProxy/core/updateAuthorizations`, body, {
        headers: generateHeaders(null, {
            'X-Transaction-ID': txnId
        })
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

module.exports = {
    createAuth,
    getEmployeeAuthorizationsByEmployeeId,
    getEmployeeAuthorizationsByEmployeeIdAndAuthorizationNumber,
    updateAuthorizationSpecialty
}